import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { listItemTileSx, listItemTextSx } from './ListItemTile.style';

export const ListItemTile = ({ onClick, icon, text, sx }) => {
  const theme = useTheme();

  return (
    <ListItem disablePadding sx={{ ...listItemTileSx(theme), ...sx }}>
      <ListItemButton onClick={onClick}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} sx={listItemTextSx(theme)} />
      </ListItemButton>
    </ListItem>
  );
};
